import {Order, ProductionStatus} from '../../types';

export function isProductionStatus(order : Order, status : ProductionStatus) : boolean {
    return order.productionStatus === status;
}